import React from 'react';
import { useTranslation } from 'react-i18next';
import DelimiterInput from '../../../shared/components/forms/inputs/DelimiterInput';
import HeaderCheckbox from './HeaderCheckbox';

interface DelimiterSectionProps {
  showDelimiterInput: boolean;
  delimiter: string;
  setDelimiter: (delimiter: string) => void;
  onProcessFiles: () => void;
  radioHasHeader?: string;
  setRadioHasHeader?: (value: string) => void;
}

const DelimiterSection: React.FC<DelimiterSectionProps> = ({
  showDelimiterInput,
  delimiter,
  setDelimiter,
  onProcessFiles,
  radioHasHeader = 'nein',
  setRadioHasHeader
}) => {
  const { t } = useTranslation('dataUpload');

  if (!showDelimiterInput) return null;

  return (
    <div className="mb-4 space-y-4">
      <DelimiterInput 
        delimiter={delimiter} 
        setDelimiter={setDelimiter} 
      />
      
      {delimiter && setRadioHasHeader && (
        <HeaderCheckbox
          hasHeader={radioHasHeader === 'ja'}
          onHeaderChange={(hasHeader) => setRadioHasHeader(hasHeader ? 'ja' : 'nein')}
        />
      )}
      
      <button
        onClick={onProcessFiles}
        className="btn btn-primary"
        disabled={!delimiter}
      >
        {t('delimiterInput.button')}
      </button>
    </div>
  );
};

export default DelimiterSection;